// Application configuration
export const config = {
  api: {
    baseURL: import.meta.env.VITE_API_URL || 'http://localhost:3001/api',
    timeout: 10000,
  },
  app: {
    name: import.meta.env.VITE_APP_NAME || 'SteerFi',
    version: import.meta.env.VITE_APP_VERSION || '1.0.0',
  },
  auth: {
    tokenKey: 'steerfi_token',
    refreshTokenKey: 'steerfi_refresh_token',
  },
} as const;
